import React, { FC } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { colors } from 'src/themes/colors';

const PagerButton = styled(Link)`
  color: ${colors.blue};
  display: inline-block;
  font-weight: 700;
  margin-top: 20px;

  &:last-child {
    margin-left: 20px;
  }
`;

interface PagerProps {
  pageContext: any;
}

const Pager: FC<PagerProps> = ({ pageContext }) => {
  const { previousPagePath, nextPagePath } = pageContext;

  return (
    <>
      {previousPagePath && (
        <PagerButton to={previousPagePath}>← Back</PagerButton>
      )}
      {nextPagePath && <PagerButton to={nextPagePath}>Next →</PagerButton>}
    </>
  );
};

export default Pager;
